import * as React from 'react';
import { makeStyles, createStyles, Box, Link } from '@material-ui/core';
import cn from 'classnames';
import { FormikProps } from 'formik';
import FormikCheck from '../../components/FormikInputWrappers/FormikCheck';
import { TranquiTheme } from '../App/theme';

interface AcceptTermsAndPolicesProps {
  formik: FormikProps<any>;
}

const AcceptTermsAndPolices: React.FC<AcceptTermsAndPolicesProps> = (props) => {
  const { formik } = props;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  return (
    <>
      <FormikCheck
        className={cn('mt-3 mb-1')}
        labelCheck={(
          <Box className={classes.textCheckBox}>
            Acepto&nbsp;
            <strong>
              <Link href="https://tranquifinanzas.com/politica-privacidad/" target="_blank">Política de tratamiento de datos</Link>
            </strong>
            ,&nbsp;
            <strong>
              <Link href="https://tranquifinanzas.com/terminos-y-condiciones-de-uso/" target="_blank">Términos y condiciones</Link>
            </strong>
              &nbsp;y&nbsp;
            <strong>
              <Link href="https://tranquifinanzas.com/aviso-de-privacidad/" target="_blank">Aviso de privacidad</Link>
            </strong>
          </Box>
          )}
        valueId="policiesAndTermsA"
        formik={formik}
      />
      <FormikCheck
        className="mt-1 mb-1"
        labelCheck={(
          <Box className={classes.textCheckBox}>
            He leído y autorizo el&nbsp;
            <strong>
              <Link href="https://tranquifinanzas.com/autorizacion-para-el-tratamiento-de-datos-personales/" target="_blank">Tratamiento de datos.</Link>
            </strong>
          </Box>
          )}
        valueId="policiesAndTermsB"
        formik={formik}
      />
    </>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  textCheckBox: {
    ...theme.typography.body2,
    color: theme.palette.text2.main,
    textAlign: 'left',
  },
}));

export default AcceptTermsAndPolices;
